/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-custom-description-tab-target]');

  if (!button) {
    return;
  }

  const tabs = button.closest('[data-custom-description-tabs]');
  const targetId = button.getAttribute('data-custom-description-tab-target');
  const targetPanel = tabs && tabs.querySelector(`[id="${targetId}"]`);

  if (!tabs || !targetPanel) {
    return;
  }

  tabs.querySelectorAll('[data-custom-description-tab-target]').forEach((tabButton) => {
    const isActive = tabButton === button;

    tabButton.classList.toggle('is-active', isActive);
    tabButton.setAttribute('aria-selected', isActive ? 'true' : 'false');
    tabButton.setAttribute('tabindex', isActive ? '0' : '-1');
  });

  tabs.querySelectorAll('.custom-description-tabs__panel').forEach((panel) => {
    const isActive = panel === targetPanel;

    panel.classList.toggle('is-active', isActive);
    panel.hidden = !isActive;
  });
});

document.addEventListener('keydown', (event) => {
  const button = event.target.closest('[data-custom-description-tab-target]');

  if (!button || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
    return;
  }

  const tabs = button.closest('[data-custom-description-tabs]');
  const buttons = tabs ? Array.from(tabs.querySelectorAll('[data-custom-description-tab-target]')) : [];
  const currentIndex = buttons.indexOf(button);

  if (currentIndex === -1) {
    return;
  }

  event.preventDefault();

  let nextIndex = currentIndex;

  if (event.key === 'Home') {
    nextIndex = 0;
  } else if (event.key === 'End') {
    nextIndex = buttons.length - 1;
  } else if (event.key === 'ArrowRight') {
    nextIndex = (currentIndex + 1) % buttons.length;
  } else if (event.key === 'ArrowLeft') {
    nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
  }

  buttons[nextIndex].focus();
  buttons[nextIndex].click();
});



/*-----------------------------------------------------------------------------/
/ CartStore patch (assets/cart-store.js)
/-----------------------------------------------------------------------------/
/ /cart.js can occasionally answer with an HTML page instead of JSON
/ (throttling, expired preview session, challenge page). Unpatched,
/ CartStore.getCart() feeds that straight into .json(), which throws
/ "SyntaxError: Unexpected token <" and is rendered verbatim next to a
/ cart line item by cart-components.js's #renderError(). Retry with
/ backoff, then fail with a message a shopper can read. Also guard
/ subscribe(): cart-store notifies subscribers synchronously during
/ add/change/update, so one throwing subscriber otherwise aborts the
/ whole cart action for every other subscriber.
/
/ This module is loaded (type="module", right after cart-store.js and
/ before cart-link.js/cart-components.js) so the patch is applied
/ synchronously before any consumer calls CartStore.getCart() or
/ Cart.subscribe() — see layout/theme.liquid.
/-----------------------------------------------------------------------------*/
import { CartStore } from "cart-store";

const originalGetCart = CartStore.getCart;
const GETCART_RETRY_DELAYS_MS = [ 400, 800 ];

CartStore.getCart = async function patchedGetCart() {
  let lastError;
  for (let attempt = 0; attempt <= GETCART_RETRY_DELAYS_MS.length; attempt++) {
    try {
      return await originalGetCart();
    } catch (e) {
      lastError = e;
      if (attempt < GETCART_RETRY_DELAYS_MS.length) {
        await new Promise((resolve) => setTimeout(resolve, GETCART_RETRY_DELAYS_MS[attempt]));
      }
    }
  }
  console.error("[cart-store patch] getCart failed after retries:", lastError);
  throw new Error("We couldn't load your cart. Please refresh the page and try again.");
};

const originalSubscribe = CartStore.prototype.subscribe;

CartStore.prototype.subscribe = function patchedSubscribe(callback) {
  const safeCallback = function (...args) {
    try {
      return callback.apply(this, args);
    } catch (e) {
      console.error("[cart-store patch] cart subscriber threw, ignoring:", e);
    }
  };
  return originalSubscribe.call(this, safeCallback);
};